var _style, _path, _defs, _path2, _defs2, _path3, _defs3, _path4, _defs4, _path5, _defs5, _path6, _path7, _defs6, _path8, _path9, _path10, _defs7, _path11, _defs8, _path12, _defs9, _path13, _defs10, _path14, _defs11, _path15, _path16, _defs12, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmeliaLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  props = _objectSpread({
    title: ''
  }, props);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      backgroundColor: "#000"
    },
    viewBox: "0 0 187.1 39",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".ameliaLogo_svg__st2{fill-rule:evenodd;clip-rule:evenodd}.ameliaLogo_svg__st14,.ameliaLogo_svg__st2{fill:#fff}")), /*#__PURE__*/React.createElement("g", {
    id: "ameliaLogo_svg__shadow",
    style: {
      opacity: 0.6
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__register_1_",
    d: "M183.1 3.4c0-.4.1-.9.4-1.2.3-.3.8-.5 1.2-.5.2 0 .5 0 .7.1.4.1.7.5.9.9.2.4.2.9 0 1.4-.1.2-.2.4-.3.5-.2.1-.3.3-.5.3-.2.1-.5.1-.7.1-.5 0-1-.2-1.2-.5-.4-.2-.5-.6-.5-1.1zm.3 0c0 .5.1.8.4 1.1.3.3.7.4 1 .4.4 0 .7-.1 1-.4.3-.2.4-.6.4-1.1s-.1-.8-.4-1.1c-.3-.2-.6-.4-1-.4s-.8.1-1 .4c-.3.4-.4.7-.4 1.1zm.7-.8h.7c.2 0 .3 0 .5.1.1.1.2.2.2.4 0 .1 0 .2-.1.3l-.2.2.3.6h-.3l-.3-.5h-.4v.5h-.3l-.1-1.6zm.3.2v.6h.3c.1 0 .2 0 .3-.1.1-.1.1-.1.1-.2 0-.2-.1-.3-.3-.3h-.4z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ameliaLogo_svg__Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 155.6,
    y: 1.8,
    width: 30.8,
    height: 36.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 155.6,
    y: 1.8,
    width: 30.8,
    height: 36.4,
    id: "ameliaLogo_svg__mask-13_1_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#ameliaLogo_svg__Adobe_OpacityMaskFilter)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__path-12_2_",
    className: "ameliaLogo_svg__st2",
    d: "M1.5 38.1h184.8V1.8H1.5z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__A_3_",
    style: {
      mask: "url(#ameliaLogo_svg__mask-13_1_)"
    },
    d: "m170.9 1.8-15.3 36.3h3l12.3-29.5 12.3 29.5h3.1z"
  }), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ameliaLogo_svg__Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 146,
    y: 3.3,
    width: 3.1,
    height: 34.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 3.3,
    width: 3.1,
    height: 34.8,
    id: "ameliaLogo_svg__mask-11_1_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#ameliaLogo_svg__Adobe_OpacityMaskFilter_1_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__path-10_2_",
    className: "ameliaLogo_svg__st2",
    d: "M1.5 38.1h184.8V1.8H1.5z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__I_1_",
    style: {
      mask: "url(#ameliaLogo_svg__mask-11_1_)"
    },
    d: "M146 38.1h3.1V3.3H146z"
  }), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ameliaLogo_svg__Adobe_OpacityMaskFilter_2_",
    filterUnits: "userSpaceOnUse",
    x: 115.3,
    y: 3.3,
    width: 21.7,
    height: 34.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 115.3,
    y: 3.3,
    width: 21.7,
    height: 34.8,
    id: "ameliaLogo_svg__mask-9_1_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#ameliaLogo_svg__Adobe_OpacityMaskFilter_2_)"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__path-8_2_",
    className: "ameliaLogo_svg__st2",
    d: "M1.5 38.1h184.8V1.8H1.5z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__L_1_",
    style: {
      mask: "url(#ameliaLogo_svg__mask-9_1_)"
    },
    d: "M115.3 38.1V3.3h3.1v31.9H137v2.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ameliaLogo_svg__E_1_"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ameliaLogo_svg__Adobe_OpacityMaskFilter_3_",
    filterUnits: "userSpaceOnUse",
    x: 88.5,
    y: 35.2,
    width: 18.7,
    height: 2.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 88.5,
    y: 35.2,
    width: 18.7,
    height: 2.9,
    id: "ameliaLogo_svg__mask-7_1_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#ameliaLogo_svg__Adobe_OpacityMaskFilter_3_)"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__path-6_2_",
    className: "ameliaLogo_svg__st2",
    d: "M1.5 38.1h184.8V1.8H1.5z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__bottom_1_",
    style: {
      mask: "url(#ameliaLogo_svg__mask-7_1_)"
    },
    d: "M88.5 38.1h18.7v-2.9H88.5z"
  }), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ameliaLogo_svg__Adobe_OpacityMaskFilter_4_",
    filterUnits: "userSpaceOnUse",
    x: 88.6,
    y: 19.1,
    width: 13.5,
    height: 2.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 88.6,
    y: 19.1,
    width: 13.5,
    height: 2.9,
    id: "ameliaLogo_svg__mask-5_1_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#ameliaLogo_svg__Adobe_OpacityMaskFilter_4_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__path-4_2_",
    className: "ameliaLogo_svg__st2",
    d: "M1.5 38.1h184.8V1.8H1.5z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__middle_1_",
    style: {
      mask: "url(#ameliaLogo_svg__mask-5_1_)"
    },
    d: "M88.6 22.1h13.5v-3H88.6z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__top_1_",
    d: "M106.5 3.3H88.6v3h17.9z"
  }))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ameliaLogo_svg__Adobe_OpacityMaskFilter_5_",
    filterUnits: "userSpaceOnUse",
    x: 40.2,
    y: 1.8,
    width: 36.3,
    height: 36.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 40.2,
    y: 1.8,
    width: 36.3,
    height: 36.4,
    id: "ameliaLogo_svg__mask-3_1_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#ameliaLogo_svg__Adobe_OpacityMaskFilter_5_)"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__path-2_2_",
    className: "ameliaLogo_svg__st2",
    d: "M40.2 1.8h36.3v36.3H40.2z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__M_1_",
    d: "M40.2 1.8c3 3.9 18.2 23.6 18.2 23.6s15-19.7 18.1-23.6v36.4h-3.1V11.3c0-.3 0-.6.1-.9-2.4 3.4-12.6 16.6-15.2 20-2.2-3-14.4-18.9-14.4-18.9-.1-.2-.3-.4-.4-.5-.1-.2-.2-.4-.4-.5 0 .3.1.6.1.9v26.9h-3.1l.1-36.5z",
    style: {
      mask: "url(#ameliaLogo_svg__mask-3_1_)"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__A_2_",
    d: "M16.7 1.8 1.5 38.1h3L16.7 8.6l12 29.5h3.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ameliaLogo_svg__amelia-white"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__register",
    className: "ameliaLogo_svg__st14",
    d: "M182.6 2.7c0-.4.1-.9.4-1.2.3-.3.8-.5 1.2-.5.2 0 .5 0 .7.1.4.1.7.5.9.9.2.4.2.9 0 1.4-.1.2-.2.4-.3.5-.2.1-.3.3-.5.3-.2.1-.5.1-.7.1-.5 0-1-.2-1.2-.5-.4-.2-.5-.7-.5-1.1zm.3 0c0 .5.1.8.4 1.1.3.3.7.4 1 .4.4 0 .7-.1 1-.4.3-.2.4-.6.4-1.1s-.1-.8-.4-1.1c-.3-.2-.6-.4-1-.4s-.8.1-1 .4c-.3.3-.4.7-.4 1.1zm.7-.9h.7c.2 0 .3 0 .5.1.1.1.2.2.2.4 0 .1 0 .2-.1.3l-.2.2.3.6h-.3l-.3-.5h-.4v.5h-.3l-.1-1.6zm.3.3v.6h.3c.1 0 .2 0 .3-.1.1-.1.1-.1.1-.2 0-.2-.1-.3-.3-.3h-.4z"
  })), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ameliaLogo_svg__Adobe_OpacityMaskFilter_6_",
    filterUnits: "userSpaceOnUse",
    x: 155.1,
    y: 1,
    width: 30.8,
    height: 36.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 155.1,
    y: 1,
    width: 30.8,
    height: 36.4,
    id: "ameliaLogo_svg__mask-13_2_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#ameliaLogo_svg__Adobe_OpacityMaskFilter_6_)"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__path-12_1_",
    className: "ameliaLogo_svg__st2",
    d: "M1 37.4h184.8V1H1z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__A",
    style: {
      mask: "url(#ameliaLogo_svg__mask-13_2_)",
      fill: "#fff"
    },
    d: "m170.4 1-15.3 36.4h3l12.3-29.5 12.3 29.5h3.1z"
  }), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ameliaLogo_svg__Adobe_OpacityMaskFilter_7_",
    filterUnits: "userSpaceOnUse",
    x: 145.5,
    y: 2.6,
    width: 3.1,
    height: 34.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 145.5,
    y: 2.6,
    width: 3.1,
    height: 34.8,
    id: "ameliaLogo_svg__mask-11_2_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#ameliaLogo_svg__Adobe_OpacityMaskFilter_7_)"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__path-10_1_",
    className: "ameliaLogo_svg__st2",
    d: "M1 37.4h184.8V1H1z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__I",
    style: {
      mask: "url(#ameliaLogo_svg__mask-11_2_)",
      fill: "#fff"
    },
    d: "M145.5 37.4h3.1V2.6h-3.1z"
  }), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ameliaLogo_svg__Adobe_OpacityMaskFilter_8_",
    filterUnits: "userSpaceOnUse",
    x: 114.8,
    y: 2.6,
    width: 21.7,
    height: 34.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 114.8,
    y: 2.6,
    width: 21.7,
    height: 34.8,
    id: "ameliaLogo_svg__mask-9_2_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#ameliaLogo_svg__Adobe_OpacityMaskFilter_8_)"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__path-8_1_",
    className: "ameliaLogo_svg__st2",
    d: "M1 37.4h184.8V1H1z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__L",
    style: {
      mask: "url(#ameliaLogo_svg__mask-9_2_)",
      fill: "#fff"
    },
    d: "M114.8 37.4V2.6h3.1v31.9h18.6v2.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ameliaLogo_svg__E"
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ameliaLogo_svg__Adobe_OpacityMaskFilter_9_",
    filterUnits: "userSpaceOnUse",
    x: 88,
    y: 34.5,
    width: 18.7,
    height: 2.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 34.5,
    width: 18.7,
    height: 2.9,
    id: "ameliaLogo_svg__mask-7_2_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#ameliaLogo_svg__Adobe_OpacityMaskFilter_9_)"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__path-6_1_",
    className: "ameliaLogo_svg__st2",
    d: "M1 37.4h184.8V1H1z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__bottom",
    style: {
      mask: "url(#ameliaLogo_svg__mask-7_2_)",
      fill: "#fff"
    },
    d: "M88 37.4h18.7v-2.9H88z"
  }), _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ameliaLogo_svg__Adobe_OpacityMaskFilter_10_",
    filterUnits: "userSpaceOnUse",
    x: 88.1,
    y: 18.4,
    width: 13.5,
    height: 2.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 88.1,
    y: 18.4,
    width: 13.5,
    height: 2.9,
    id: "ameliaLogo_svg__mask-5_2_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#ameliaLogo_svg__Adobe_OpacityMaskFilter_10_)"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__path-4_1_",
    className: "ameliaLogo_svg__st2",
    d: "M1 37.4h184.8V1H1z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__middle",
    style: {
      mask: "url(#ameliaLogo_svg__mask-5_2_)",
      fill: "#fff"
    },
    d: "M88.1 21.3h13.5v-2.9H88.1z"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__top",
    className: "ameliaLogo_svg__st14",
    d: "M106 2.6H88.1v3H106z"
  }))), _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ameliaLogo_svg__Adobe_OpacityMaskFilter_11_",
    filterUnits: "userSpaceOnUse",
    x: 39.7,
    y: 1,
    width: 36.3,
    height: 36.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 39.7,
    y: 1,
    width: 36.3,
    height: 36.4,
    id: "ameliaLogo_svg__mask-3_2_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#ameliaLogo_svg__Adobe_OpacityMaskFilter_11_)"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__path-2_1_",
    className: "ameliaLogo_svg__st2",
    d: "M39.7 1H76v36.4H39.7z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__M",
    d: "M39.7 1c3 3.9 18.2 23.6 18.2 23.6S72.9 4.9 76 1v36.4h-3.1V10.5c0-.3 0-.6.1-.9-2.4 3.4-12.6 16.6-15.2 20-2.2-3-14.4-18.9-14.4-18.9-.1-.2-.3-.4-.4-.5-.1-.2-.2-.4-.4-.5 0 .3.1.6.1.9v26.9h-3.1L39.7 1z",
    style: {
      mask: "url(#ameliaLogo_svg__mask-3_2_)",
      fill: "#fff"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "ameliaLogo_svg__A_1_",
    className: "ameliaLogo_svg__st14",
    d: "M16.2 1 1 37.4h3L16.2 7.9l12 29.5h3.1z"
  }))));
}
export { SvgAmeliaLogo as ReactComponent };
export default "data:image/svg+xml;base64,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";